<template>
  <div>
    <el-dialog 
      title="上传文件并输入查重率" 
      :visible.sync="dialogVisible"
      @open="resetForm">
      {{ id }}
      <el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
        <!-- 上传文件 -->
        <el-form-item label="上传文件" prop="file">
          <el-upload
            class="upload-demo"
            action="" 
            :auto-upload="false"
            :file-list="fileList"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :limit="1"
            :on-exceed="handleExceed">
            <el-button size="small" type="primary">选取文件</el-button>
          </el-upload>
        </el-form-item>

        <!-- 查重率输入 -->
        <el-form-item label="查重率 (%)" prop="cfl">
          <el-input
            v-model="form.cfl"
            placeholder="请输入查重率"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    // 正则说明：
    // 0~99.99 或 0~100.00，最多两位小数
    const cflRegex = /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/;
    
    return {
      dialogVisible: false,
      type: 'thesis2',
      thesisId: '',
      fileList: [],
      form: {
        cfl: '',
        file: null
      },
      rules: {
        file: [
          { required: true, message: '请先上传文件', trigger: 'change' }
        ],
        cfl: [
          { required: true, message: '请输入查重率', trigger: 'blur' },
          { pattern: cflRegex, message: '查重率必须在 0~100，最多两位小数', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    open(id, type = 'thesis2') {
      this.thesisId = id
      this.dialogVisible = true
      this.type = type
    },
    handleFileChange(file, fileList) {
      this.form.file = file.raw;
      this.fileList = fileList;
      this.$nextTick(() => {
        this.$refs.formRef.validateField('file');
      });
    },
    handleFileRemove(file, fileList) {
      // 删除文件时清空 form.file
      this.form.file = null;
      this.fileList = fileList;
      this.$nextTick(() => {
        this.$refs.formRef.validateField('file');
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning('只能上传一个文件哦');
    },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          console.log('上传文件:', this.form.file);
          console.log('查重率:', this.form.cfl);
          const formData = new FormData()
          formData.append('file', this.form.file)
          formData.append('cfl', this.form.cfl)
          formData.append('thesisId', this.thesisId)

          this.$http.post(`/student/${this.type == 'degree' ? 'degree' : 'thesis2'}/uploadDc`, formData).then(() => {
            this.$emit('refresh')
            this.$message.success('提交成功');
            this.dialogVisible = false;
          })
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },
    resetForm() {
      this.fileList = [];
      this.form = {
        cfl: '',
        file: null
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    }
  }
};
</script>
